// @ts-nocheck
/* eslint-disable */
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */

'use strict'

function peg$subclass(child, parent) {
    function ctor() {
        this.constructor = child
    }
    ctor.prototype = parent.prototype
    child.prototype = new ctor()
}

function peg$SyntaxError(message, expected, found, location) {
    this.message = message
    this.expected = expected
    this.found = found
    this.location = location
    this.name = 'SyntaxError'

    if (typeof Error.captureStackTrace === 'function') {
        Error.captureStackTrace(this, peg$SyntaxError)
    }
}

peg$subclass(peg$SyntaxError, Error)

peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
        literal: function (expectation) {
            return '"' + literalEscape(expectation.text) + '"'
        },

        class: function (expectation) {
            var escapedParts = '',
                i

            for (i = 0; i < expectation.parts.length; i++) {
                escapedParts +=
                    expectation.parts[i] instanceof Array
                        ? classEscape(expectation.parts[i][0]) + '-' + classEscape(expectation.parts[i][1])
                        : classEscape(expectation.parts[i])
            }

            return '[' + (expectation.inverted ? '^' : '') + escapedParts + ']'
        },

        any: function (expectation) {
            return 'any character'
        },

        end: function (expectation) {
            return 'end of input'
        },

        other: function (expectation) {
            return expectation.description
        }
    }

    function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase()
    }

    function literalEscape(s) {
        return s
            .replace(/\\/g, '\\\\')
            .replace(/"/g, '\\"')
            .replace(/\0/g, '\\0')
            .replace(/\t/g, '\\t')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/[\x00-\x0F]/g, function (ch) {
                return '\\x0' + hex(ch)
            })
            .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                return '\\x' + hex(ch)
            })
    }

    function classEscape(s) {
        return s
            .replace(/\\/g, '\\\\')
            .replace(/\]/g, '\\]')
            .replace(/\^/g, '\\^')
            .replace(/-/g, '\\-')
            .replace(/\0/g, '\\0')
            .replace(/\t/g, '\\t')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/[\x00-\x0F]/g, function (ch) {
                return '\\x0' + hex(ch)
            })
            .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                return '\\x' + hex(ch)
            })
    }

    function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation)
    }

    function describeExpected(expected) {
        var descriptions = new Array(expected.length),
            i,
            j

        for (i = 0; i < expected.length; i++) {
            descriptions[i] = describeExpectation(expected[i])
        }

        descriptions.sort()

        if (descriptions.length > 0) {
            for (i = 1, j = 1; i < descriptions.length; i++) {
                if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i]
                    j++
                }
            }
            descriptions.length = j
        }

        switch (descriptions.length) {
            case 1:
                return descriptions[0]

            case 2:
                return descriptions[0] + ' or ' + descriptions[1]

            default:
                return descriptions.slice(0, -1).join(', ') + ', or ' + descriptions[descriptions.length - 1]
        }
    }

    function describeFound(found) {
        return found ? '"' + literalEscape(found) + '"' : 'end of input'
    }

    return 'Expected ' + describeExpected(expected) + ' but ' + describeFound(found) + ' found.'
}

function peg$parse(input, options) {
    options = options !== void 0 ? options : {}

    var peg$FAILED = {},
        peg$startRuleFunctions = {File: peg$parseFile},
        peg$startRuleFunction = peg$parseFile,
        peg$c0 = function (element) {
            return element
        },
        peg$c1 = function (node) {
            return node
        },
        peg$c2 = function (value) {
            return {type: 'text', value}
        },
        peg$c3 = '<![CDATA[',
        peg$c4 = peg$literalExpectation('<![CDATA[', false),
        peg$c5 = ']]>',
        peg$c6 = peg$literalExpectation(']]>', false),
        peg$c7 = function (data) {
            return {type: 'cdata', value: data.join('')}
        },
        peg$c8 = peg$anyExpectation(),
        peg$c9 = function (c) {
            return c
        },
        peg$c10 = '<',
        peg$c11 = peg$literalExpectation('<', false),
        peg$c12 = '>',
        peg$c13 = peg$literalExpectation('>', false),
        peg$c14 = '</',
        peg$c15 = peg$literalExpectation('</', false),
        peg$c16 = function (elementInfo, children, closingTag) {
            return elementInfo.tag === closingTag
        },
        peg$c17 = function (elementInfo, children, closingTag) {
            return {...elementInfo, type: 'element', children}
        },
        peg$c18 = '/>',
        peg$c19 = peg$literalExpectation('/>', false),
        peg$c20 = function (elementInfo) {
            return {...elementInfo, type: 'element', children: []}
        },
        peg$c21 = function (tag, attributes) {
            return {tag, attributes}
        },
        peg$c22 = function (tag) {
            return tag
        },
        peg$c23 = function (attributes) {
            return Object.fromEntries(attributes)
        },
        peg$c24 = '=',
        peg$c25 = peg$literalExpectation('=', false),
        peg$c26 = '"',
        peg$c27 = peg$literalExpectation('"', false),
        peg$c28 = function (key, value) {
            return [key, value]
        },
        peg$c29 = '',
        peg$c30 = /^[^&<>"\u2013\u2014\xA9\xAE\u2122\u2248\u2260\xA3\u20AC\xB0]/,
        peg$c31 = peg$classExpectation(
            [
                '&',
                '<',
                '>',
                '"',
                '\u2013',
                '\u2014',
                '\xA9',
                '\xAE',
                '\u2122',
                '\u2248',
                '\u2260',
                '\xA3',
                '\u20AC',
                '\xB0'
            ],
            true,
            false
        ),
        peg$c32 = function (value) {
            return value.join('').trim()
        },
        peg$c33 = '&amp;',
        peg$c34 = peg$literalExpectation('&amp;', false),
        peg$c35 = '&lt;',
        peg$c36 = peg$literalExpectation('&lt;', false),
        peg$c37 = '&gt;',
        peg$c38 = peg$literalExpectation('&gt;', false),
        peg$c39 = '&quot;',
        peg$c40 = peg$literalExpectation('&quot;', false),
        peg$c41 = '&ndash;',
        peg$c42 = peg$literalExpectation('&ndash;', false),
        peg$c43 = '&mdash;',
        peg$c44 = peg$literalExpectation('&mdash;', false),
        peg$c45 = '&copy;',
        peg$c46 = peg$literalExpectation('&copy;', false),
        peg$c47 = '&reg;',
        peg$c48 = peg$literalExpectation('&reg;', false),
        peg$c49 = '&trade;',
        peg$c50 = peg$literalExpectation('&trade;', false),
        peg$c51 = '&asymp;',
        peg$c52 = peg$literalExpectation('&asymp;', false),
        peg$c53 = '&ne;',
        peg$c54 = peg$literalExpectation('&ne;', false),
        peg$c55 = '&pound;',
        peg$c56 = peg$literalExpectation('&pound;', false),
        peg$c57 = '&euro;',
        peg$c58 = peg$literalExpectation('&euro;', false),
        peg$c59 = '&deg;',
        peg$c60 = peg$literalExpectation('&deg;', false),
        peg$c61 = function (entity) {
            return ENTITIES_TO_CHAR[entity]
        },
        peg$c62 = /^[a-zA-Z0-9_\-]/,
        peg$c63 = peg$classExpectation([['a', 'z'], ['A', 'Z'], ['0', '9'], '_', '-'], false, false),
        peg$c64 = function (value) {
            return value.join('')
        },
        peg$c65 = /^[ \t\n\r]/,
        peg$c66 = peg$classExpectation([' ', '\t', '\n', '\r'], false, false),
        peg$currPos = 0,
        peg$savedPos = 0,
        peg$posDetailsCache = [{line: 1, column: 1}],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result

    if ('startRule' in options) {
        if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error('Can\'t start parsing from rule "' + options.startRule + '".')
        }

        peg$startRuleFunction = peg$startRuleFunctions[options.startRule]
    }

    function text() {
        return input.substring(peg$savedPos, peg$currPos)
    }

    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos)
    }

    function expected(description, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

        throw peg$buildStructuredError(
            [peg$otherExpectation(description)],
            input.substring(peg$savedPos, peg$currPos),
            location
        )
    }

    function error(message, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

        throw peg$buildSimpleError(message, location)
    }

    function peg$literalExpectation(text, ignoreCase) {
        return {type: 'literal', text: text, ignoreCase: ignoreCase}
    }

    function peg$classExpectation(parts, inverted, ignoreCase) {
        return {type: 'class', parts: parts, inverted: inverted, ignoreCase: ignoreCase}
    }

    function peg$anyExpectation() {
        return {type: 'any'}
    }

    function peg$endExpectation() {
        return {type: 'end'}
    }

    function peg$otherExpectation(description) {
        return {type: 'other', description: description}
    }

    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos],
            p

        if (details) {
            return details
        } else {
            p = pos - 1
            while (!peg$posDetailsCache[p]) {
                p--
            }

            details = peg$posDetailsCache[p]
            details = {
                line: details.line,
                column: details.column
            }

            while (p < pos) {
                if (input.charCodeAt(p) === 10) {
                    details.line++
                    details.column = 1
                } else {
                    details.column++
                }

                p++
            }

            peg$posDetailsCache[pos] = details
            return details
        }
    }

    function peg$computeLocation(startPos, endPos) {
        var startPosDetails = peg$computePosDetails(startPos),
            endPosDetails = peg$computePosDetails(endPos)

        return {
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        }
    }

    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) {
            return
        }

        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos
            peg$maxFailExpected = []
        }

        peg$maxFailExpected.push(expected)
    }

    function peg$buildSimpleError(message, location) {
        return new peg$SyntaxError(message, null, null, location)
    }

    function peg$buildStructuredError(expected, found, location) {
        return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location)
    }

    function peg$parseFile() {
        var s0, s1, s2, s3

        s0 = peg$currPos
        s1 = peg$parse_()
        if (s1 !== peg$FAILED) {
            s2 = peg$parseElement()
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_()
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c0(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseNode() {
        var s0, s1, s2, s3

        s0 = peg$currPos
        s1 = peg$parse_()
        if (s1 !== peg$FAILED) {
            s2 = peg$parseElement()
            if (s2 === peg$FAILED) {
                s2 = peg$parseCData()
                if (s2 === peg$FAILED) {
                    s2 = peg$parseText()
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_()
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c1(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseText() {
        var s0, s1

        s0 = peg$currPos
        s1 = peg$parseValue()
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0
            s1 = peg$c2(s1)
        }
        s0 = s1

        return s0
    }

    function peg$parseCData() {
        var s0, s1, s2, s3

        s0 = peg$currPos
        if (input.substr(peg$currPos, 9) === peg$c3) {
            s1 = peg$c3
            peg$currPos += 9
        } else {
            s1 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c4)
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = []
            s3 = peg$parseCDataContent()
            while (s3 !== peg$FAILED) {
                s2.push(s3)
                s3 = peg$parseCDataContent()
            }
            if (s2 !== peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c5) {
                    s3 = peg$c5
                    peg$currPos += 3
                } else {
                    s3 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c6)
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c7(s2)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseCDataContent() {
        var s0, s1, s2, s3

        s0 = peg$currPos
        s1 = peg$currPos
        peg$silentFails++
        if (input.substr(peg$currPos, 3) === peg$c5) {
            s2 = peg$c5
            peg$currPos += 3
        } else {
            s2 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c6)
            }
        }
        peg$silentFails--
        if (s2 === peg$FAILED) {
            s1 = void 0
        } else {
            peg$currPos = s1
            s1 = peg$FAILED
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$currPos
            peg$silentFails++
            if (input.substr(peg$currPos, 9) === peg$c3) {
                s3 = peg$c3
                peg$currPos += 9
            } else {
                s3 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c4)
                }
            }
            peg$silentFails--
            if (s3 === peg$FAILED) {
                s2 = void 0
            } else {
                peg$currPos = s2
                s2 = peg$FAILED
            }
            if (s2 !== peg$FAILED) {
                if (input.length > peg$currPos) {
                    s3 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s3 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c8)
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c9(s3)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseElement() {
        var s0

        s0 = peg$parseContainerElement()
        if (s0 === peg$FAILED) {
            s0 = peg$parseEmptyElement()
        }

        return s0
    }

    function peg$parseContainerElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14

        s0 = peg$currPos
        if (input.charCodeAt(peg$currPos) === 60) {
            s1 = peg$c10
            peg$currPos++
        } else {
            s1 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c11)
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_()
            if (s2 !== peg$FAILED) {
                s3 = peg$parseElementInfo()
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_()
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 62) {
                            s5 = peg$c12
                            peg$currPos++
                        } else {
                            s5 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c13)
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_()
                            if (s6 !== peg$FAILED) {
                                s7 = []
                                s8 = peg$parseNode()
                                while (s8 !== peg$FAILED) {
                                    s7.push(s8)
                                    s8 = peg$parseNode()
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_()
                                    if (s8 !== peg$FAILED) {
                                        if (input.substr(peg$currPos, 2) === peg$c14) {
                                            s9 = peg$c14
                                            peg$currPos += 2
                                        } else {
                                            s9 = peg$FAILED
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c15)
                                            }
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_()
                                            if (s10 !== peg$FAILED) {
                                                s11 = peg$parseTag()
                                                if (s11 !== peg$FAILED) {
                                                    s12 = peg$parse_()
                                                    if (s12 !== peg$FAILED) {
                                                        if (input.charCodeAt(peg$currPos) === 62) {
                                                            s13 = peg$c12
                                                            peg$currPos++
                                                        } else {
                                                            s13 = peg$FAILED
                                                            if (peg$silentFails === 0) {
                                                                peg$fail(peg$c13)
                                                            }
                                                        }
                                                        if (s13 !== peg$FAILED) {
                                                            peg$savedPos = peg$currPos
                                                            s14 = peg$c16(s3, s7, s11)
                                                            if (s14) {
                                                                s14 = void 0
                                                            } else {
                                                                s14 = peg$FAILED
                                                            }
                                                            if (s14 !== peg$FAILED) {
                                                                peg$savedPos = s0
                                                                s1 = peg$c17(s3, s7, s11)
                                                                s0 = s1
                                                            } else {
                                                                peg$currPos = s0
                                                                s0 = peg$FAILED
                                                            }
                                                        } else {
                                                            peg$currPos = s0
                                                            s0 = peg$FAILED
                                                        }
                                                    } else {
                                                        peg$currPos = s0
                                                        s0 = peg$FAILED
                                                    }
                                                } else {
                                                    peg$currPos = s0
                                                    s0 = peg$FAILED
                                                }
                                            } else {
                                                peg$currPos = s0
                                                s0 = peg$FAILED
                                            }
                                        } else {
                                            peg$currPos = s0
                                            s0 = peg$FAILED
                                        }
                                    } else {
                                        peg$currPos = s0
                                        s0 = peg$FAILED
                                    }
                                } else {
                                    peg$currPos = s0
                                    s0 = peg$FAILED
                                }
                            } else {
                                peg$currPos = s0
                                s0 = peg$FAILED
                            }
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseEmptyElement() {
        var s0, s1, s2, s3, s4, s5

        s0 = peg$currPos
        if (input.charCodeAt(peg$currPos) === 60) {
            s1 = peg$c10
            peg$currPos++
        } else {
            s1 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c11)
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_()
            if (s2 !== peg$FAILED) {
                s3 = peg$parseElementInfo()
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_()
                    if (s4 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 2) === peg$c18) {
                            s5 = peg$c18
                            peg$currPos += 2
                        } else {
                            s5 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c19)
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            peg$savedPos = s0
                            s1 = peg$c20(s3)
                            s0 = s1
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseElementInfo() {
        var s0, s1, s2, s3

        s0 = peg$currPos
        s1 = peg$parseTag()
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_()
            if (s2 !== peg$FAILED) {
                s3 = peg$parseAttributes()
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0
                    s1 = peg$c21(s1, s3)
                    s0 = s1
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseTag() {
        var s0, s1

        s0 = peg$currPos
        s1 = peg$parseSimpleValue()
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0
            s1 = peg$c22(s1)
        }
        s0 = s1

        return s0
    }

    function peg$parseAttributes() {
        var s0, s1, s2

        s0 = peg$currPos
        s1 = []
        s2 = peg$parseAttribute()
        while (s2 !== peg$FAILED) {
            s1.push(s2)
            s2 = peg$parseAttribute()
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0
            s1 = peg$c23(s1)
        }
        s0 = s1

        return s0
    }

    function peg$parseAttribute() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11

        s0 = peg$currPos
        s1 = peg$parse_()
        if (s1 !== peg$FAILED) {
            s2 = peg$parseSimpleValue()
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_()
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 61) {
                        s4 = peg$c24
                        peg$currPos++
                    } else {
                        s4 = peg$FAILED
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c25)
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_()
                        if (s5 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 34) {
                                s6 = peg$c26
                                peg$currPos++
                            } else {
                                s6 = peg$FAILED
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c27)
                                }
                            }
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parse_()
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseOptionalValue()
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$parse_()
                                        if (s9 !== peg$FAILED) {
                                            if (input.charCodeAt(peg$currPos) === 34) {
                                                s10 = peg$c26
                                                peg$currPos++
                                            } else {
                                                s10 = peg$FAILED
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$c27)
                                                }
                                            }
                                            if (s10 !== peg$FAILED) {
                                                s11 = peg$parse_()
                                                if (s11 !== peg$FAILED) {
                                                    peg$savedPos = s0
                                                    s1 = peg$c28(s2, s8)
                                                    s0 = s1
                                                } else {
                                                    peg$currPos = s0
                                                    s0 = peg$FAILED
                                                }
                                            } else {
                                                peg$currPos = s0
                                                s0 = peg$FAILED
                                            }
                                        } else {
                                            peg$currPos = s0
                                            s0 = peg$FAILED
                                        }
                                    } else {
                                        peg$currPos = s0
                                        s0 = peg$FAILED
                                    }
                                } else {
                                    peg$currPos = s0
                                    s0 = peg$FAILED
                                }
                            } else {
                                peg$currPos = s0
                                s0 = peg$FAILED
                            }
                        } else {
                            peg$currPos = s0
                            s0 = peg$FAILED
                        }
                    } else {
                        peg$currPos = s0
                        s0 = peg$FAILED
                    }
                } else {
                    peg$currPos = s0
                    s0 = peg$FAILED
                }
            } else {
                peg$currPos = s0
                s0 = peg$FAILED
            }
        } else {
            peg$currPos = s0
            s0 = peg$FAILED
        }

        return s0
    }

    function peg$parseOptionalValue() {
        var s0

        s0 = peg$parseValue()
        if (s0 === peg$FAILED) {
            s0 = peg$c29
        }

        return s0
    }

    function peg$parseValue() {
        var s0, s1, s2

        s0 = peg$currPos
        s1 = []
        if (peg$c30.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos)
            peg$currPos++
        } else {
            s2 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c31)
            }
        }
        if (s2 === peg$FAILED) {
            s2 = peg$parseReservedChar()
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2)
                if (peg$c30.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c31)
                    }
                }
                if (s2 === peg$FAILED) {
                    s2 = peg$parseReservedChar()
                }
            }
        } else {
            s1 = peg$FAILED
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0
            s1 = peg$c32(s1)
        }
        s0 = s1

        return s0
    }

    function peg$parseReservedChar() {
        var s0, s1

        s0 = peg$currPos
        if (input.substr(peg$currPos, 5) === peg$c33) {
            s1 = peg$c33
            peg$currPos += 5
        } else {
            s1 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c34)
            }
        }
        if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c35) {
                s1 = peg$c35
                peg$currPos += 4
            } else {
                s1 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c36)
                }
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 4) === peg$c37) {
                    s1 = peg$c37
                    peg$currPos += 4
                } else {
                    s1 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c38)
                    }
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 6) === peg$c39) {
                        s1 = peg$c39
                        peg$currPos += 6
                    } else {
                        s1 = peg$FAILED
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c40)
                        }
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 7) === peg$c41) {
                            s1 = peg$c41
                            peg$currPos += 7
                        } else {
                            s1 = peg$FAILED
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c42)
                            }
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 7) === peg$c43) {
                                s1 = peg$c43
                                peg$currPos += 7
                            } else {
                                s1 = peg$FAILED
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c44)
                                }
                            }
                            if (s1 === peg$FAILED) {
                                if (input.substr(peg$currPos, 6) === peg$c45) {
                                    s1 = peg$c45
                                    peg$currPos += 6
                                } else {
                                    s1 = peg$FAILED
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c46)
                                    }
                                }
                                if (s1 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 5) === peg$c47) {
                                        s1 = peg$c47
                                        peg$currPos += 5
                                    } else {
                                        s1 = peg$FAILED
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c48)
                                        }
                                    }
                                    if (s1 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 7) === peg$c49) {
                                            s1 = peg$c49
                                            peg$currPos += 7
                                        } else {
                                            s1 = peg$FAILED
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c50)
                                            }
                                        }
                                        if (s1 === peg$FAILED) {
                                            if (input.substr(peg$currPos, 7) === peg$c51) {
                                                s1 = peg$c51
                                                peg$currPos += 7
                                            } else {
                                                s1 = peg$FAILED
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$c52)
                                                }
                                            }
                                            if (s1 === peg$FAILED) {
                                                if (input.substr(peg$currPos, 4) === peg$c53) {
                                                    s1 = peg$c53
                                                    peg$currPos += 4
                                                } else {
                                                    s1 = peg$FAILED
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c54)
                                                    }
                                                }
                                                if (s1 === peg$FAILED) {
                                                    if (input.substr(peg$currPos, 7) === peg$c55) {
                                                        s1 = peg$c55
                                                        peg$currPos += 7
                                                    } else {
                                                        s1 = peg$FAILED
                                                        if (peg$silentFails === 0) {
                                                            peg$fail(peg$c56)
                                                        }
                                                    }
                                                    if (s1 === peg$FAILED) {
                                                        if (input.substr(peg$currPos, 6) === peg$c57) {
                                                            s1 = peg$c57
                                                            peg$currPos += 6
                                                        } else {
                                                            s1 = peg$FAILED
                                                            if (peg$silentFails === 0) {
                                                                peg$fail(peg$c58)
                                                            }
                                                        }
                                                        if (s1 === peg$FAILED) {
                                                            if (input.substr(peg$currPos, 5) === peg$c59) {
                                                                s1 = peg$c59
                                                                peg$currPos += 5
                                                            } else {
                                                                s1 = peg$FAILED
                                                                if (peg$silentFails === 0) {
                                                                    peg$fail(peg$c60)
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0
            s1 = peg$c61(s1)
        }
        s0 = s1

        return s0
    }

    function peg$parseSimpleValue() {
        var s0, s1, s2

        s0 = peg$currPos
        s1 = []
        if (peg$c62.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos)
            peg$currPos++
        } else {
            s2 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c63)
            }
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2)
                if (peg$c62.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos)
                    peg$currPos++
                } else {
                    s2 = peg$FAILED
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c63)
                    }
                }
            }
        } else {
            s1 = peg$FAILED
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0
            s1 = peg$c64(s1)
        }
        s0 = s1

        return s0
    }

    function peg$parse_() {
        var s0, s1

        s0 = []
        if (peg$c65.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos)
            peg$currPos++
        } else {
            s1 = peg$FAILED
            if (peg$silentFails === 0) {
                peg$fail(peg$c66)
            }
        }
        while (s1 !== peg$FAILED) {
            s0.push(s1)
            if (peg$c65.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos)
                peg$currPos++
            } else {
                s1 = peg$FAILED
                if (peg$silentFails === 0) {
                    peg$fail(peg$c66)
                }
            }
        }

        return s0
    }

    const ENTITIES_TO_CHAR = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&ndash;': '–',
        '&mdash;': '—',
        '&copy;': '©',
        '&reg;': '®',
        '&trade;': '™',
        '&asymp;': '≈',
        '&ne;': '≠',
        '&pound;': '£',
        '&euro;': '€',
        '&deg;': '°'
    }

    peg$result = peg$startRuleFunction()

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
        return peg$result
    } else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail(peg$endExpectation())
        }

        throw peg$buildStructuredError(
            peg$maxFailExpected,
            peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
            peg$maxFailPos < input.length
                ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
                : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
        )
    }
}

export {peg$parse as parse}
